/**
 * Turn a machine key into a human label:
 * ``downloaded_count`` → "Downloaded Count", ``baseDir`` → "Base Dir".
 * A digit inside an acronym stays attached (``N4M rule`` → "N4M Rule",
 * ``EMI02`` stays whole) while ``s3Bucket`` still splits into "S3 Bucket".
 */
export function humanizeKey(key: string): string {
  return key
    .replace(/[_-]+/g, " ")
    .replace(/(?<![A-Z])([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
